import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { canAccess } from "@/lib/roles";

export default function ProtectedRoute({ children, page }) {
    const { user } = useAuth();
    const location = useLocation();

    if (user === undefined) {
        return (
            <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
                <div className="text-sm text-neutral-500 font-display">Loading BS Fiber ERP...</div>
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/login" replace state={{ from: location.pathname }} />;
    }
    if (page && !canAccess(user, page)) {
        return <Navigate to="/" replace />;
    }
    return children;
}
